import zhCN from 'ant-design-vue/es/locale/zh_CN';
import enUS from 'ant-design-vue/es/locale/en_US';
import { i18n } from '@/locales';
import axios from './store/interface';
import { setItemToCookie, getItemFromCookie } from './utils/url-tools';
// import locale from 'ant-design-vue/lib/date-picker/locale/en_US';

export default {
  data() {
    return {
      locale: zhCN,
      localeConfig: {
        'zhCN': zhCN,
        'enUS': enUS
      },
      language: 'zhCN',
      localStorage: localStorage,
      showLanguage: false
    };
  },
  watch: {
    $route(to, from) {
      if (to.path === '/' || to.path.indexOf('/login') > -1) {
        this.showLanguage = true;
      } else {
        this.showLanguage = false;
      }
    }
  },
  created() {
    // const lang = localStorage.getItem('lang') || 'zhCN'
    // this.language = lang
    // this.setLanguage(lang)
    this.setLanguageByCookie();
  },
  methods: {
    onLanguageChange(e) {
      this.setLanguage(e);
      this.setLanguageToCookie(e);
      location.reload();
    },
    setLanguage(language) {
      i18n.global.locale = language;
      this.locale = this.localeConfig[language];
      localStorage.setItem('lang', language);
    },
    setLanguageByCookie() {
      //更新token
      const langInCookie = getItemFromCookie('languageType');
      let resLangInCookie = 'zhCN';
      if (langInCookie === 'en_US') {
        resLangInCookie = 'enUS';
      }
      this.language = resLangInCookie;
      this.setLanguage(resLangInCookie);
    },
    setLanguageToCookie(lang) {
      let resLang = 'zh_CN';
      if (lang === 'enUS') {
        resLang = 'en_US';
      }
      setItemToCookie('languageType', resLang, null, '/', '', null);
    }
  }
};